module.exports = __webpack_public_path__ + "static/media/milk.7e05c8db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/milk.png
// module id = 32
// module chunks = 0